import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "time12Hour",
  standalone: true,
  pure: false,
})
export class Time12HourPipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return "";

    // Ensure the value is a string
    let [hours, minutes] = value.toString().split(":").splice(0, 2).map(Number);

    // Determine AM or PM
    const period = hours >= 12 ? "PM" : "AM";

    // Convert 24-hour time to 12-hour format
    hours = hours % 12 || 12; // Convert 0 to 12 for midnight

    // Return formatted time
    return `${this.padZero(hours)}:${this.padZero(minutes)} ${period}`;
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
}
